import { createReducer, on } from "@ngrx/store";
import { initialCreateLearnerState } from "./create-learner.state";
import { CreateLearner, CreateLearnerError, CreateLearnerSuccess, ResetCreateLearnerState, SetLearner } from "./create-learner.actions";

export const CreateLearnerReducers = createReducer(
  initialCreateLearnerState,
  on(SetLearner, (state, action) => {
    return {
      ...state,
      learner: { ...state.learner, ...action.dto}
    };
  }),
  on(CreateLearner, (state) => {
    return {
      ...state,
      loading: true,
      result: null,
      error: null
    }
  }),
  on(CreateLearnerSuccess, (state, action) => {
    return {
      ...state,
      loading: false,
      result: action.result
    }
  }),
  on(CreateLearnerError, (state, action) => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  }),
  on(ResetCreateLearnerState, (state) => {
    return {
      ...state,
      ...initialCreateLearnerState
    };
  })
)